export default class SizeGuideTable extends HTMLElement {
  private unitButtons: HTMLButtonElement[] = [];
  private values: HTMLElement[] = [];

  private onUnitButtonClickBound = this.onUnitButtonClick.bind(this);

  static observedAttributes = ['data-unit'];

  connectedCallback(): void {
    this.unitButtons = Array.from(
      this.querySelectorAll<HTMLButtonElement>('[data-size-guide-table-ref="unit-button"]'),
    );
    this.values = Array.from(this.querySelectorAll<HTMLElement>('[data-size-guide-table-ref="value"]'));

    if (this.unitButtons.length < 2) {
      return;
    }

    this.addEventListeners();
    this.syncUnitState();
  }

  disconnectedCallback(): void {
    this.removeEventListeners();
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (name === 'data-unit' && oldValue !== newValue) {
      this.syncUnitState();
    }
  }

  private addEventListeners(): void {
    this.unitButtons.forEach((button) => {
      button.addEventListener('click', this.onUnitButtonClickBound);
    });
  }

  private removeEventListeners(): void {
    this.unitButtons.forEach((button) => {
      button.removeEventListener('click', this.onUnitButtonClickBound);
    });
  }

  private onUnitButtonClick(event: Event): void {
    const button = event.currentTarget as HTMLButtonElement;
    const unit = button.dataset.unit;

    if (!unit || unit === this.dataset.unit) {
      return;
    }

    this.dataset.unit = unit;
  }

  private syncUnitState(): void {
    const activeUnit = this.dataset.unit;

    this.values.forEach((value) => {
      value.hidden = value.dataset.unit !== activeUnit;
    });

    this.unitButtons.forEach((button) => {
      const isActive = button.dataset.unit === activeUnit;
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }
}

customElements.define('size-guide-table', SizeGuideTable);
